import React, { Component } from "react";

import { reactLocalStorage } from "reactjs-localstorage";
// import { NaverMap } from "react-naver-maps";
import {
  Form,
  Modal,
  Input,
  Button,

} from "antd";
import { httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import { showAlert } from "../common/AlertModal";


const FormItem = Form.Item;
const CouponCategoryRegistry = Form.create()(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        name:"",
        price:"",
        count:"",
        


      
      };
      
    }

  


    onRegistry = (e) => {
      const { form } = this.props;

      e.preventDefault();
      form.validateFields((err, values) => {
        let createData = {
          ...values,
         
        };
      
        if (!err) {
          if (global.confirm("생성하시겠습니까?"))
            httpPost(httpUrl.CouponCategoryCreate, [], createData)
              .then((res) => {
                if (res.data) {
                  this.props.onOk();
                  form.resetFields();
                  showAlert("create");
                } else {
                  
                    alert("알수없는 오류로 실패하였습니다.");
                  
                }
              })
              .catch((error) => {
                alert("알수없는 오류로 실패하였습니다.");

              });
        }
      });
    };

    onCancel = () => {
      this.props.form.resetFields();
      this.props.onCancel();
      
    };

    componentDidMount() {}

    render() {
      const {
      
      } = this.state;
      const { visible, form, defaultValue, color } = this.props;
      const { getFieldDecorator } = form;
      
      const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 }
        }
      };

      

      return (
        <Modal
          visible={visible}
          title="쿠폰 생성"
          okText="생성"
          cancelText="취소"
          onOk={this.onRegistry}
          onCancel={this.onCancel}
          style={{ minWidth: "400px" }}>
         
         <Form {...formItemLayout} onSubmit={this.onRegistry} >
        
        <FormItem label={<span>쿠폰종류&nbsp;</span>}>
          {getFieldDecorator("name", {
            rules: [
              {
                required: true,
                message: "이름을 입력해주세요!",
                
              },
            ]
            
          })(<Input placeholder="이름을 입력하세요" />)}
        </FormItem>             
        <FormItem label={<span>쿠폰금액&nbsp;</span>}>
          {getFieldDecorator("price", {
            rules: [
              {
                required: true,
                message: "금액을 입력해주세요!"
              },
              
            ]
  
          })(<Input placeholder="금액을 입력하세요" />)}
        </FormItem>       
        <FormItem label={<span>쿠폰수량&nbsp;</span>}>
          {getFieldDecorator("count", {
            rules: [
              {
                required: true,
                message: "수량을 입력해주세요!"
              },
              
            ]
  
          })(<Input placeholder="수량을 입력하세요" />)}
        </FormItem>    
             
          </Form>
        </Modal>
      );
    }
  }
);

export default CouponCategoryRegistry;


